import type { GuestContactMethod } from '@repo/api-contracts';

/** 비회원 연락 방법 라벨(비회원 견적 설계 G14) — 목록 배지 옆과 상세 연락처가 공유한다. */
export const GUEST_CONTACT_METHOD_LABELS: Readonly<Record<GuestContactMethod, string>> = {
  EMAIL: '이메일',
  PHONE: '휴대폰',
};
